import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M21.25 12a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m-8.5 10c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m.75-16A.75.75 0 0 0 12 6v6c0 .284.16.544.415.67l4 2a.75.75 0 1 0 .67-1.34L13.5 11.536z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }